import React from 'react';

const CopySVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 2 22 22"
      fill='currentColor'
      strokeWidth='0.05'
      stroke='currentColor'
      {...props}
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        d="M13.5 2H13ZM2 8C2 6.89543 2.89543 6 4 6H12C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8H4V16C4 16.5523 3.55228 17 3 17C2.44772 17 2 16.5523 2 16V8ZM6 12C6 10.8954 6.89543 10 8 10H16C17.1046 10 18 10.8954 18 12V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V12ZM16 12H8V20H16V12Z"
      />
    </svg>
  );
};

export { CopySVG };
